module.exports = __webpack_public_path__ + "static/4-94e4effac2c7b7e2f1d8d47447ce883a.jpg";